<template>
  <div class="generate">
    <div class="operate-plate">
      <span class="plate-tips">智能描述</span>
      <div class="text-wrapper">
        <textarea
          class="plate-text"
          :placeholder="aiKeywords || `请输入4-100个字符`"
          v-model="aiKeywordsComputed"
          minlength="4"
          maxlength="100"
          cols="30"
          rows="7"
        ></textarea>
        <span class="count">{{ aiKeywordsComputed.length }}/100</span>
      </div>
      <button @click="reGenProducts" class="ai-btn generate-btn">
        <span v-if="isLoading" class="loading-icon"></span>
        <template v-else>
          一键生成
          <i class="icon"></i>
        </template>
      </button>
      <ai-products :products="products" @addToPreview="addToPreview" />
    </div>
    <div class="stage-plate">
      <ai-samples
        :materialSuites="materialSuites"
        :currentMaterialSuite="currentMaterialSuite"
        :isLoading="isLoading"
        :thumbPaperwork="thumbPaperwork"
        @switchStyle="switchStyle"
        @checkMaterialSuite="checkMaterialSuite"
      />
      <div class="performance">
        <div :class="`${product.enName}-wrapper`" v-for="product of choicedProducts" :key="product.enName">
          <template v-if="product.isShow">
            <span class="name">{{ product.name }}</span>
            <ai-poster
              v-if="product.enName === 'poster'"
              class="poster-pro"
              :size="posterData.size"
              :elConfig="posterData.elementInfo"
              :bgConfig="posterData.bgParameter"
              :elementImg="posterData.elementImg"
              :textInfo="posterData.textInfo"
              :contentStyle="posterData.contentStyle"
              :posterTextMaps="posterTextMaps"
              @changeQRCode="changeQRCode"
              @maskClick="handleMaskClick"
            />
            <ai-banner
              class="banner-pro"
              v-if="product.enName === 'banner'"
              :bannerTextValue="bannerData.textValue"
              :size="bannerData.size"
              :elConfig="bannerData.elementInfo"
              :bgConfig="bannerData.bgParameter"
              :elementImg="bannerData.elementImg"
              :textInfo="bannerData.textInfo"
              :textStyles="bannerData.textStyle"
              @maskClick="handleMaskClick"
            />
            <ai-cover
              v-if="product.enName === 'cover'"
              class="cover-pro"
              :bgConfig="coverData.bgParameter"
              :elementImg="coverData.elementImg"
              :size="coverData.size"
              :elConfig="coverData.elementInfo"
              :textConfig="coverData.textInfo"
              :fontStyles="coverData.fontStyles"
              @maskClick="handleMaskClick"
            >
            </ai-cover>
            <ai-loading v-if="isLoading" />
          </template>
        </div>
        <button :class="['ai-btn next-btn', { disabled: isLoading || !choicedProducts.length }]" @click="nextStep">
          下一步
        </button>
      </div>
    </div>
    <ai-dialog
      v-if="isAiDialogVisible"
      :tagId="currentMaterialSuite.background.tagIds[0]"
      @update:visible="isAiDialogVisible = false"
      @replaceElement="replaceElement"
    >
    </ai-dialog>
  </div>
</template>
<script>
import { genMaterialData, getLabelStyleMenu, randomSort } from "@/assets/scripts/common.js";
import { getSizeInfo, getTextStylesBySizeId } from "@/assets/scripts/features";
import { formatMainTextStyles } from "@/pages/poster/js/poster-struct";
import { genBannerDataBySize, isLabelStyleVisible } from "@/pages/banner/js/banner-feature";
import { genCoverDataBySize } from "@/pages/cover/js/cover-feature";
import {
  genSizeStyleTextInfo,
  genTextStylesByIconStyle,
  getContentStyles,
  randomContentStyleByTag,
  randomIconStyle,
} from "@/pages/poster/js/poster-feature";
import { mapMutations, mapState } from "vuex";
import aiDialog from "./components/ai-dialog.vue";
import aiBanner from "./components/ai-banner.vue";
import aiCover from "./components/ai-cover.vue";
import AiLoading from "./components/ai-loading.vue";
import aiPoster from "./components/ai-poster.vue";
import aiProducts from "./components/ai-products.vue";
import aiSamples from "./components/ai-samples.vue";
import {
  getBannerSizes,
  getBannerTextLimit,
  getCoverSizes,
  getCoverTextLimit,
  getMaterialsByWords,
  getPaperworks,
  getPosterPaperwork,
  getSizeInfoBySizeId,
  thumbSize,
  genPosterTextMapFromAi,
  randomPosterLabelStyle,
} from "./js/ai-feature";
export default {
  name: "generate",
  components: {
    aiPoster,
    aiBanner,
    aiCover,
    aiSamples,
    aiProducts,
    AiLoading,
    aiDialog,
  },
  data() {
    return {
      // 默认的poster 的size和text信息
      posterSizeInfo: {},
      posterTextStyles: [],
      isLoading: false,
      aiKeywordsComputed: "",
      isAiDialogVisible: false,
    };
  },
  computed: {
    ...mapState("posterLong", ["posterTextMaps", "posterData"]),
    ...mapState("banner", ["bannerData", "bannerDataList"]),
    ...mapState("cover", ["coverDataList", "coverData"]),
    ...mapState("ai", [
      "products",
      "aiKeywords",
      "aiBackgrounds",
      "aiElements",
      "contentStyles",
      "materialSuites",
      "currentMaterialSuite",
      "thumbPaperwork",
    ]),
    // 被选中的产品
    choicedProducts() {
      return this.products.filter(product => product.isShow);
    },
  },
  async mounted() {
    const { words } = this.$route.query;
    this.aiKeywordsComputed = words;
    await this.getSizeAndTextInfo();
    // 比较aiKeywords和words，如果不一样，则更新aiKeywords
    if (words && this.aiKeywords !== words) {
      this.isLoading = true;
      await this.genProducts();
      this.updateAiKeywords(words);
      this.isLoading = false;
    }
  },
  watch: {
    // posterTextMaps: {
    //   async handler(blocks) {
    //     const newPosterDatas = JSON.parse(JSON.stringify(blocks));
    //     newPosterDatas.forEach((item) => {});
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    "bannerData.textValue": {
      async handler(texts) {
        // 只更新普通尺寸的BannerDataList中的文字
        this.modifyBannerDataList({
          condition: item => item.type === 0,
          params: { textValue: texts },
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations("posterLong", ["updatePosterData", "updatePosterTextMaps"]),
    ...mapMutations("banner", [
      "updateBannerData",
      "clearBannerDataList",
      "setBannerTextStyles",
      "modifyBannerDataList",
    ]),
    ...mapMutations("cover", ["updateCoverDataList", "updateCoverData"]),
    ...mapMutations("ai", [
      "setCurrentMaterialSuite",
      "updateAiKeywords",
      "setAiElements",
      "setMaterialSuites",
      "setProduct",
      "setAllSizes",
    ]),
    // 获取默认的postersize和text信息
    async getSizeAndTextInfo() {
      const posterSizeId = process.env.VUE_APP_POSTER_SIZE_ID;
      return Promise.all([getSizeInfo(posterSizeId), getTextStylesBySizeId(posterSizeId)]).then(
        ([posterSizeInfo, posterTextStyles]) => {
          this.posterSizeInfo = posterSizeInfo;
          this.posterTextStyles = posterTextStyles;
        }
      );
    },
    // 生成产品
    async genProducts() {
      // 文字行数
      const textStyleId = 2;
      return Promise.all([getBannerSizes(textStyleId), getCoverSizes()]).then(([bannerSizes, coverSizes]) => {
        const bannerSizeId = process.env.VUE_APP_BANNER_SIZE_ID;
        // 获取banner尺寸的文案限制
        const bannerTextLimits = getBannerTextLimit(bannerSizes, bannerSizeId);
        // 获取cover尺寸的文案限制,顺便加上了缩略图的文案限制
        const coverTextLimits = getCoverTextLimit(coverSizes);
        // 增加文案
        return Promise.all([
          getMaterialsByWords(this.aiKeywordsComputed, 1),
          getMaterialsByWords(this.aiKeywordsComputed, 2),
          getContentStyles(),
          getPosterPaperwork(this.aiKeywordsComputed),
          getPaperworks(this.aiKeywordsComputed, bannerTextLimits),
          getPaperworks(this.aiKeywordsComputed, [...coverTextLimits, thumbSize]),
        ]).then(([bgs, eles, contentStyles, posterPaperworks, allBannerPaperworks, allCoverPaperworks]) => {
          this.setAiElements({
            backgrounds: bgs,
            elements: eles,
            contentStyles,
          });
          // 生成素材套件作为推荐,并且默认选中第一个素材套件作为currentMaterialSuite
          this.setMaterialSuites(this.genMaterialSuites(eles, bgs, contentStyles));
          const { background, element, contentStyle } = this.currentMaterialSuite;
          // 设置所有尺寸
          this.setAllSizes({
            allBannerSizes: bannerSizes,
            allBannerPaperworks,
            allCoverPaperworks,
            allCoverSizes: coverSizes,
          });
          // 初始化poster
          const tagIds = background.tagIds;
          const posterData = {
            tagId: tagIds[0],
            contentStyleId: contentStyle.id,
            contentStyle: {
              bottomBg: contentStyle.bottomBg,
              filePath: contentStyle.filePath,
              repeatBg: contentStyle.repeatBg,
            },
            ...genMaterialData(element, background),
            ...genSizeStyleTextInfo({
              sizeInfo: this.posterSizeInfo,
              fontId: this.posterTextStyles[0].id,
            }),
            isAiElement: false,
          };
          // 海报文案
          const posterTextMaps = genPosterTextMapFromAi(posterPaperworks, this.posterTextMaps);
          // 主标题样式
          const mainTextStyles = formatMainTextStyles(posterTextMaps[0].editOptions, this.posterTextStyles[0].styles);
          Object.assign(posterTextMaps[0].editOptions, mainTextStyles);
          // 随机生成一个label样式
          randomPosterLabelStyle(posterTextMaps, background.tagBgColor);
          this.updatePosterData(posterData);
          this.updatePosterTextMaps(posterTextMaps);
          const bannerSize = getSizeInfoBySizeId(bannerSizes, bannerSizeId);
          const bannerData = genBannerDataBySize(bannerSize, element, background);
          bannerData.isAiElement = false;
          bannerData.textStyle = this.randomLabelStyle(bannerData.textStyle, "banner");
          this.updateBannerData(bannerData);
          this.clearBannerDataList();
          // 初始化cover
          const coverSizeId = process.env.VUE_APP_COVER_SIZE_ID;
          const coverSize = getSizeInfoBySizeId(coverSizes, coverSizeId);
          const cover = genCoverDataBySize(coverSize, element, background);
          cover.fontStyles = this.randomLabelStyle(cover.fontStyles, "cover");
          cover.isAiElement = false;
          this.updateCoverData(cover);
          this.updateCoverDataList({ isClearCoverDataList: true });
        });
      });
    },
    // 重新生成cover、banner、poster
    async reGenProducts() {
      if (this.isLoading) return;
      if (this.aiKeywords.length < 2 || this.aiKeywords.length > 100) {
        this.$message.error("请输入2-100个字符");
        return;
      }
      // 路由的words参数也需要更新，且路由修改不需要记录
      if (this.aiKeywordsComputed !== this.aiKeywords) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            words: this.aiKeywordsComputed,
          },
        });
        this.updateAiKeywords(this.aiKeywordsComputed);
      }
      this.isLoading = true;
      await this.genProducts();
      this.isLoading = false;
    },
    // 添加到预览
    addToPreview(product) {
      this.setProduct(product);
    },
    // 去下载cover
    nextStep() {
      if (this.isLoading || !this.choicedProducts.length) return;
      this.$router.push({
        path: "/ai/size-choose",
      });
    },
    // 修改posterData
    changeQRCode(params) {
      this.updatePosterTextMaps(params);
    },
    // 生成素材套件
    genMaterialSuites(eles, bgs, contentStyles) {
      const suites = [];
      const tagMap = {};
      // 背景已按新鲜度排好，优先用靠前的
      let availableBgs = [...bgs];
      eles.forEach(element => {
        // 按照素材的tagIds，筛选出相同tag的背景图列表
        // tagIds是数组，需要遍历数组
        const matchedBags = [];
        element.tagIds.forEach(eTagId => {
          matchedBags.push(...availableBgs.filter(b => b.tagIds.includes(eTagId)));
        });
        const pool = matchedBags.length ? matchedBags : availableBgs;
        const background = pool[0];
        if (!background) return;
        // 从可用背景池中移除已使用的背景
        availableBgs = availableBgs.filter(item => item.id !== background.id);
        // 如果可用背景池为空，重新填充
        if (availableBgs.length === 0) {
          availableBgs = [...bgs];
        }
        const tagIds = background.tagIds;
        suites.push({
          element,
          background,
          id: `${element.id}-${background.id}`,
          contentStyle: randomContentStyleByTag(contentStyles, tagIds[0]),
          iconStyle: randomIconStyle(),
        });
        tagIds[0] && (tagMap[tagIds[0]] = true);
      });

      // 获取所有标签ID
      const tagIds = Object.keys(tagMap);

      // 重新排序suites，使相同tagIds的元素不相邻
      const result = [];

      while (suites.length > 0) {
        const nextItem = suites.find(suite => tagIds.includes(suite.background.tagIds));

        if (nextItem) {
          result.push(nextItem);
          suites.splice(suites.indexOf(nextItem), 1);
        } else {
          // 如果找不到不同的tagId，就把剩余的元素都加入
          result.push(...suites);
          break;
        }
      }
      return result;
    },
    // 选中素材
    checkMaterialSuite(materialSuite, isChangeFontStyle) {
      const { element, background, iconStyle, contentStyle } = materialSuite;
      if (element.id === this.currentMaterialSuite.element.id) return;
      this.setCurrentMaterialSuite(materialSuite);
      const meterialMap = genMaterialData(element, background);
      const bTag = background.tagIds;
      const posterTextMaps = genTextStylesByIconStyle(this.posterTextMaps, iconStyle);
      const posterData = {
        ...meterialMap,
        tagId: bTag[0],
        contentStyleId: contentStyle.id,
        contentStyle,
        isAiElement: false,
      };
      if (isChangeFontStyle) {
        randomPosterLabelStyle(posterTextMaps, background.tagBgColor);
      }
      this.updatePosterTextMaps(posterTextMaps);
      this.updatePosterData(posterData);
      // 初始化banner
      const bannerData = {
        ...meterialMap,
        tagId: bTag[0],
        isAiElement: false,
      };
      if (isChangeFontStyle) {
        bannerData.textStyle = this.randomLabelStyle(this.bannerData.textStyle, "banner");
      }
      this.updateBannerData(bannerData);
      this.clearBannerDataList();
      const coverData = {
        ...meterialMap,
        tagId: bTag[0],
        isAiElement: false,
      };
      if (isChangeFontStyle) {
        coverData.fontStyles = this.randomLabelStyle(this.coverData.fontStyles, "cover");
      }
      this.updateCoverData(coverData);
      this.updateCoverDataList({ isClearCoverDataList: true });
    },
    switchStyle(materialSuite) {
      // 修改文字样式
      const isChangeFontStyle = true;
      this.checkMaterialSuite(materialSuite, isChangeFontStyle);
    },
    // 文字随机选择一个label样式
    randomLabelStyle(textStyle, productName) {
      const textStyles = JSON.parse(JSON.stringify(textStyle));
      const tagBgColor = this.currentMaterialSuite.background.tagBgColor;
      let condition = false;
      for (let id = 0; id < textStyles.length; id++) {
        if (productName === "banner") {
          condition = isLabelStyleVisible(textStyles, id);
        } else if (productName === "cover") {
          condition = ["阿里巴巴普惠体 Regular", "阿里巴巴普惠体 Light"].includes(textStyles[id].fontFamily);
        }
        // 是否需要显示label样式
        if (condition) {
          // 随机选择一个label样式
          const labelStyleMap = getLabelStyleMenu(tagBgColor);
          const labelStyle = randomSort(Object.values(labelStyleMap))[0];
          textStyles[id].labelStyle = labelStyle.name;
          textStyles[id].showLabelStyle = true;
          textStyles[id].isLabelStyle = true;
        }
      }
      return textStyles;
    },
    // 打开生成图片对话框
    handleMaskClick() {
      this.isAiDialogVisible = true;
    },
    // 替换元素
    replaceElement(img) {
      // 替换banner的元素
      this.bannerData.elementImg = img.imageUrl;
      this.bannerData.elementId = img.id;
      this.bannerData.isAiElement = img.isAiElement;
      this.updateBannerData({
        elementImg: img.imageUrl,
        elementId: img.id,
        isAiElement: true,
      });
      // 替换cover的元素
      this.coverData.elementImg = img.imageUrl;
      this.coverData.elementId = img.id;
      this.updateCoverData({
        elementImg: img.imageUrl,
        elementId: img.id,
        isAiElement: true,
      });
      // 替换poster的元素
      this.posterData.elementImg = img.imageUrl;
      this.posterData.elementId = img.id;
      this.updatePosterData({
        elementImg: img.imageUrl,
        elementId: img.id,
        isAiElement: true,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.generate {
  display: flex;
  height: calc(100vh - 60px);
  justify-content: space-around;
  padding: 16px;
  gap: 16px;
  background: #020202;
  .operate-plate {
    width: 22%;
    max-width: 400px;
    padding: 24px;
    border-radius: 16px;
    background: rgba(33, 37, 49, 0.9);
    box-shadow:
      0px 0px 0px 0px rgba(0, 0, 0, 0),
      0px 0px 0px 1px rgba(244, 244, 245, 0.05),
      0px 0px 0px 0px #fff;
    .plate-tips {
      display: block;
      line-height: 24px;
      color: rgba(255, 255, 255, 0.6);
      font-size: 16px;
    }
    .plate-text {
      display: block;
      padding: 16px 24px;
      width: 100%;
      margin-top: 8px;
      border-radius: 16px;
      border: 1px solid rgba(148, 131, 255, 0.3);
      background: #181b24;
      box-shadow:
        0px 0px 0px 0px rgba(0, 0, 0, 0),
        0px 0px 0px 1px rgba(244, 244, 245, 0.05),
        0px 0px 0px 0px #fff;
      color: #fff;
      font-size: 16px;
      resize: none;
    }
    .generate-btn {
      max-width: 240px;
      display: block;
      width: 100%;
      margin: 32px auto 0;
    }
    .text-wrapper {
      position: relative;
      .count {
        position: absolute;
        bottom: 24px;
        right: 24px;
        color: #9483ff;
        font-size: 12px;
      }
    }
  }
  .stage-plate {
    position: relative;
    width: 77%;
    flex: 1;
    border-radius: 16px;
    background: rgba(33, 37, 49, 0.9);
    overflow: auto;
    &:before {
      content: "";
      position: absolute;
      top: 200px;
      left: 0;
      width: 100%;
      height: 1px;
      background: #3c375d;
    }
    .performance {
      max-width: 1230px;
      width: 98%;
      margin: 0 auto;
      overflow: hidden;
      .poster-wrapper,
      .banner-wrapper,
      .cover-wrapper {
        position: relative;
        margin-top: 18px;
        float: left;
        // &:not(:first-child) {
        //   margin-left: 16px;
        // }
        .ai-loading {
          top: 32px;
        }
      }
      .poster-wrapper {
        margin-right: 16px;
        .poster-pro {
          transform-origin: 0 0;
        }
      }
      .banner-wrapper {
        width: 828px;
        height: 287px;
        .banner-pro {
          transform-origin: 0 0;
          transform: scale(0.85);
        }
      }
      .cover-wrapper {
        width: 437px;
        height: 302px;
        .cover-pro {
          transform-origin: 0 0;
          transform: scale(1.5);
        }
      }
      .name {
        display: block;
        margin-bottom: 8px;
        height: 24px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.6);
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 500;
      }
    }
    .next-btn {
      position: absolute;
      bottom: 24px;
      right: 24px;
      width: 160px;
      &.disabled {
        opacity: 0.4;
      }
    }
  }
}
@media screen and (max-width: 1860px) {
  .generate {
    padding: 12px;
    gap: 12px;
    .operate-plate {
      padding: 12px;
      width: 18%;
    }
    .stage-plate {
      width: 81%;
    }
  }
}
@media screen and (max-width: 1610px) {
  .generate {
    .operate-plate {
      width: 21%;
    }
    .stage-plate {
      .performance {
        .poster-wrapper {
          width: 259px;
          height: 492px;
          .poster-pro {
            transform: scale(0.69);
          }
        }
        .banner-wrapper {
          width: 720px;
          height: 252px;
          .banner-pro {
            transform: scale(0.74);
          }
        }
        .cover-wrapper {
          width: 437px;
          height: 302px;
          .cover-pro {
            transform: scale(1);
          }
        }
      }
    }
  }
}
</style>
